module.exports = __webpack_public_path__ + "static/media/28-Lainez(1).78f84b65.png";